const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba80d17c-2b45-4ba0-800a-859f8d5c5fa4",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.49 17.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "f36769c1-1a41-49a5-b1bc-92fe61f980bc",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e1a331ee-61fa-489a-9400-67068f830ef7",
    "data-name": "Icon awesome-user-alt",
    d: "M6.74,7.54A3.57,3.57,0,1,0,3.18,4,3.57,3.57,0,0,0,6.74,7.54Zm3.18.79H8.55a4.3,4.3,0,0,1-3.61,0H3.57A3.17,3.17,0,0,0,.4,11.5v.4a1.19,1.19,0,0,0,1.19,1.19H11.9a1.19,1.19,0,0,0,1.19-1.19v-.4A3.17,3.17,0,0,0,9.92,8.33Z",
    style: {
      fill: "none",
      stroke: "#575757",
      strokeWidth: "0.800000011920929px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.27,
    y: 11.27,
    width: 8.98,
    height: 5.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "fec34da8-6789-4ef1-88a3-01630d8ee232",
    "data-name": "Icon awesome-key",
    d: "M4,13.86a2,2,0,0,1,2.78,0,3.25,3.25,0,0,1,.23.29l.4,0a.32.32,0,0,1,.21.08l.29.29.31-.31a.26.26,0,0,1,.38,0h0l.32.31.31-.31a.26.26,0,0,1,.38,0h0l.89.88a.28.28,0,0,1,0,.38l-.62.61a.27.27,0,0,1-.19.08H7.19a2,2,0,1,1-3.5-1.77,1.92,1.92,0,0,1,.36-.5Zm1,1.77a.54.54,0,0,0,0-.76.53.53,0,0,0-.75,0,.54.54,0,0,0,0,.76h0A.53.53,0,0,0,5.05,15.63Z",
    style: {
      fill: "none",
      stroke: "#575757",
      strokeWidth: "0.799999998229512px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconAdmin);
export default __webpack_public_path__ + "static/media/user_icon_admin.d0a449370e6349a2da372633a43d5b24.svg";
export { ForwardRef as ReactComponent };